import first from "lodash/first";
import qs from "qs";
export const getWhyRegisterActionKey = query => {
  var _parsedQueryString$ac, _parsedQueryString$ac2;
  const parsedQueryString = qs.parse(query, {
    ignoreQueryPrefix: true
  });
  return first(Object.keys((_parsedQueryString$ac = (_parsedQueryString$ac2 = parsedQueryString.action) === null || _parsedQueryString$ac2 === void 0 ? void 0 : _parsedQueryString$ac2.ppto_why_reg) !== null && _parsedQueryString$ac !== void 0 ? _parsedQueryString$ac : {}));
};
export const getDestinationString = trackingActionName => {
  const destination = new URL(window.location.origin + window.location.pathname);
  destination.search = `action[ppto_why_reg][${trackingActionName}]`;
  return destination.toString();
};